import { labelForScope } from '../scopes';
import type { Scope } from '../scopes';
import { SCOPES } from '../scopes';

interface Props {
  scope: Scope;
}

export function ScopeDot({ scope }: Props) {
  const color = SCOPES.find((s) => s.id === scope)?.color ?? '#94a3b8';
  return (
    <span
      className="scope-dot"
      style={{ backgroundColor: color }}
      title={labelForScope(scope)}
      aria-label={`Scope ${labelForScope(scope)}`}
    />
  );
}
